// extracted by mini-css-extract-plugin
export default {"fullHeight":"J8PCdqx9"};